export const navigation = [
  {
    name: 'Services',
    href: '/services',
    dropdown: [
      { name: 'Call Handling',              href: '/services#call-handling' },
      { name: 'Virtual Receptionist',       href: '/services#virtual-receptionist' },
      { name: 'Email Monitoring',           href: '/services#email-monitoring' },
      { name: 'Duty of Care Calls',         href: '/services#duty-of-care' },
      { name: 'Appointment Reminders',      href: '/services#appointment-reminders' },
      { name: 'After-Hours Emergency Line', href: '/services#emergency-line' },
      { name: 'Complaint First Response',   href: '/services#complaint-handling' },
      { name: 'Outbound Satisfaction Calls',href: '/services#satisfaction-calls' },
      { name: 'Order Taking',               href: '/services#order-taking' },
    ],
  },
  {
    name: 'Industries',
    href: '/industries',
    dropdown: [
      { name: 'Healthcare & Medical',       href: '/industries#healthcare' },
      { name: 'Trades & Engineering',       href: '/industries#trades' },
      { name: 'Transport & Logistics',      href: '/industries#logistics' },
      { name: 'Professional Services',      href: '/industries#professional' },
      { name: 'IT & Technology',            href: '/industries#it' },
      { name: 'Finance',                    href: '/industries#finance' },
      { name: 'Retail & E-commerce',        href: '/industries#retail' },
      { name: 'Manufacturing',              href: '/industries#manufacturing' },
      { name: 'Facilities & Field Services',href: '/industries#facilities' },
      { name: 'Estate Agents & Property',   href: '/industries#property' },
      { name: 'Legal',                      href: '/industries#legal' },
      { name: 'Education',                  href: '/industries#education' },
      { name: 'Automotive',                 href: '/industries#automotive' },
      { name: 'Energy & Utilities',         href: '/industries#energy' },
      { name: 'Security & Alarm Companies', href: '/industries#security' },
      { name: 'Charities & Helplines',      href: '/industries#charity' },
    ],
  },
  { name: 'Pricing',   href: '/pricing' },
  { name: 'About Us',  href: '/about-us' },
  { name: 'FAQ',       href: '/faq' },
  { name: 'Contact',   href: '/contact' },
];
